<form [formGroup]="gOLineTypesForm" class="example-form settings-form">

    <mat-form-field>
        <mat-label>{{'FORM.gOLineTypesForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required >
    </mat-form-field>

    <mat-form-field >
        <mat-label>{{'FORM.gOLineTypesForm.lineColorName' | translate}}</mat-label>
        <input matInput formControlName="lineColorName" value="{{lineColorNameData}}" readonly/>
        <ngx-colors
          class="suffix"
          matSuffix
          ngx-colors-trigger
          [hideTextInput]="false"
          [format]="'hex'"
          formControlName="lineColorName"
        ></ngx-colors>
        <mat-error *ngIf="gOLineTypesForm.controls['lineColorName'].hasError('invalidColor')" > The color is invalid. </mat-error>
    </mat-form-field>

    <!-- <mat-form-field>
        <mat-label>{{'FORM.gOLineTypesForm.lineColorName' | translate}}</mat-label>
        <input formControlName="lineColorName" matInput type="color" >

        <div *ngIf="data.data" style="display:none;"><p >{{data.data.lineColorName}}</p></div>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'FORM.gOLineTypesForm.lineColorNameOpacity' | translate}}</mat-label>
        <input formControlName="lineColorNameOpacity" id="opacityNumber"style="width:100%;" type="range" name="opacity" min="0" max="1" step="0.01" [value]="lineColorNameOpacity" oninput="amount.value = opacityNumber.value" >
        <input formControlName="lineColorNameOpacity" matInput id="amount" type="number" [value]="lineColorNameOpacity" min="0" max="1" step="0.01" oninput="opacityNumber.value=amount.value" />
        
        <p style="display:none;">{{newAvalue}}</p>
    </mat-form-field> -->

    <mat-form-field>
        <mat-label>{{'FORM.gOLineTypesForm.lineWidth' | translate}}</mat-label>
            <button mat-icon-button matPrefix (click)="substractLineWidth()"><mat-icon>remove</mat-icon></button>
            <input formControlName="lineWidth" matInput type="number" min="0" >
            <button mat-icon-button matSuffix (click)="addLineWidth()"><mat-icon>add</mat-icon></button>
    </mat-form-field>

    <mat-slide-toggle class="example-margin m-1 slide-toggle-text" formControlName="testInterval">
        {{'FORM.gOLineTypesForm.testInterval' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin m-1 slide-toggle-text" formControlName="notificationChannel">
        {{'FORM.gOLineTypesForm.notificationChannel' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin m-1 slide-toggle-text" formControlName="usageInformation">
        {{'FORM.gOLineTypesForm.usageInformation' | translate}}
    </mat-slide-toggle>

    <div>
        <button class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()" 
        [disabled]="!gOLineTypesForm.value.lineColorName || gOLineTypesForm.controls['lineColorName'].hasError('invalidColor') || gOLineTypesForm.controls['lineColorName'].hasError('required') || gOLineTypesForm.invalid || updateRight">   
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>
        <button [disabled]="gOLineTypesForm.invalid || deleteRight" class="w-100 second-stt-btn mb-2" 
        mat-button style="float:inline-end;" (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>
    
</form>

<!-- <ng-template injectComp></ng-template> -->